import React, { ReactNode } from 'react';
import { useAppDispatch } from '../../hooks';

interface Props {
    children: ReactNode;
    handleClose: () => void
}

const Button: React.FC<Props> = ({
    children,
    handleClose
}) => {
    return (
        <>
            <a href="#" onClick={handleClose} className="close">{children}</a>
        </>
    )
}

export default Button;